// This component has been autogenerated with 'generate:components' script

import { cx } from 'classix'
import styles from 'icons/Icon.module.css'
import type { IconProps } from 'icons/types/Icon.types'
import { DEFAULT_ICON_COLOR, DEFAULT_ICON_SIZE } from 'icons/utils/constants'

export const IconPauseL = ({
	alt,
	className,
	color = DEFAULT_ICON_COLOR,
	height = DEFAULT_ICON_SIZE,
	lang,
	width = DEFAULT_ICON_SIZE,
	rotateRtl,
}: IconProps): React.ReactNode => {
	const computedClassName = cx(
		styles[`icon-${color}`],
		rotateRtl && styles['rotate-rtl'],
		className
	)

	return (
		// biome-ignore lint/a11y/noSvgWithoutTitle: The <title> tag error is false positive error
		<svg
			xmlns='http://www.w3.org/2000/svg'
			xmlSpace='preserve'
			viewBox='0 0 24 24'
			width={width}
			height={height}
			aria-hidden={alt ? undefined : 'true'}
			className={computedClassName}
			data-testid='pause-l'
		>
			{alt && <title lang={lang}>{alt}</title>}
			<path d='M14 5h1v15h-1zM9 20h1V5H9z' />
		</svg>
	)
}
